var _g, _ellipse, _path, _path2, _path3, _path4, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _path5, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _rect13, _path13, _path14, _path15, _rect14, _path16, _path17, _rect15, _path18, _path19, _rect16, _path20, _path21, _rect17, _path22, _path23, _rect18, _path24, _path25, _rect19, _path26, _path27, _rect20, _path28, _path29, _rect21, _path30, _path31, _rect22, _path32, _path33, _rect23, _path34, _path35, _rect24, _path36, _path37, _rect25, _path38, _path39, _rect26, _path40, _path41, _rect27, _path42, _path43, _rect28, _path44, _path45, _path46, _rect29, _path47, _path48, _path49, _rect30, _path50, _path51, _path52, _path53, _path54, _ellipse2, _path55, _path56, _path57, _ellipse3, _path58, _path59, _path60, _ellipse4, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _rect31, _rect32, _rect33, _path75, _path76, _rect34, _path77, _path78, _path79, _rect35, _rect36, _rect37, _path80, _path81, _rect38, _path82, _path83, _path84, _rect39, _rect40, _rect41, _path85, _path86, _rect42, _path87, _path88, _rect43, _path89, _path90, _path91, _rect44, _path92, _path93, _path94, _rect45, _path95, _path96, _path97, _rect46, _path98, _path99, _path100, _rect47, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _g2, _g3, _g4, _g5, _g6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProductHuntCuate(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#ebebeb"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.58 329.22h26.48v11.19H40.58zM25.81 343.33h26.48v11.19H25.81zM79.19 34.79h26.48v11.19H79.19zM64.41 48.9h26.48v11.19H64.41zM49.7 34.79h26.48v11.19H49.7zM449.24 316.65h26.48v11.19h-26.48zM290.32 34.79h26.48v11.19h-26.48zM436 208.5h26.48v11.19H436zM418.41 33.33h26.48v11.19h-26.48zM433.18 47.44h26.48v11.19h-26.48zM23.22 128.6H49.7v11.19H23.22zM53.58 186h26.48v11.19H53.58z"
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 243.91,
    cy: 453.03,
    rx: 213.84,
    ry: 10.25,
    fill: "#ebebeb"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M17.99 418.48l58-.24 58.01-.09 116-.17 116 .17 58.01.08 58 .25-58 .24-58.01.09-116 .17-116-.17-58.01-.09-58-.24z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M114.81 75.71h334.43v334.43H114.81z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#dbdbdb",
    d: "M130.61 93.97h302.84v297.44H130.61z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M130.61 316.96h302.84v10.57H130.61zM130.61 238h302.84v10.57H130.61zM130.61 159.02h302.84v10.57H130.61z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 138.09,
    y: 129.53,
    width: 29.5,
    height: 29.5,
    rx: 3.09,
    fill: "#fff"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 168.53,
    y: 129.53,
    width: 29.5,
    height: 29.5,
    rx: 3.09,
    fill: "#fff"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 138.09,
    y: 99.37,
    width: 29.5,
    height: 29.5,
    rx: 3.09,
    fill: "#fff"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 168.53,
    y: 99.37,
    width: 29.5,
    height: 29.5,
    rx: 3.09,
    fill: "#fff"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 198.93,
    y: 129.53,
    width: 29.5,
    height: 29.5,
    rx: 3.09,
    fill: "#fff"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 198.93,
    y: 99.37,
    width: 29.5,
    height: 29.5,
    rx: 3.09,
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#c7c7c7",
    d: "M136.13 120.88h93.65v23.4h-93.65z"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 234.48,
    y: 129.53,
    width: 29.5,
    height: 29.5,
    rx: 3.09,
    fill: "#fff"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 264.93,
    y: 129.53,
    width: 29.5,
    height: 29.5,
    rx: 3.09,
    fill: "#fff"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 234.48,
    y: 99.37,
    width: 29.5,
    height: 29.5,
    rx: 3.09,
    fill: "#fff"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 264.93,
    y: 99.37,
    width: 29.5,
    height: 29.5,
    rx: 3.09,
    fill: "#fff"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 295.33,
    y: 129.53,
    width: 29.5,
    height: 29.5,
    rx: 3.09,
    fill: "#fff"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 295.33,
    y: 99.37,
    width: 29.5,
    height: 29.5,
    rx: 3.09,
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#ebebeb",
    d: "M232.53 120.88h93.65v23.4h-93.65z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M161.61 222v16h-25.48v-16c0-7.28 4-11.72 4-14s-3-5.8-3-10.24 5.8-8.13 5.8-11.44V177h11.82v9.32c0 3.31 5.81 7 5.81 11.44s-3 8-3 10.24 4.05 6.76 4.05 14z",
    fill: "#c7c7c7"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#ebebeb",
    d: "M141.13 173.85h15.47v5.23h-15.47z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M136.13 223.02h25.48v9.27h-25.48z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M189.92 222v16h-25.47v-16c0-7.28 4-11.72 4-14s-2.95-5.8-2.95-10.24 5.8-8.13 5.8-11.44V177h11.8v9.32c0 3.31 5.8 7 5.8 11.44s-3 8-3 10.24 4.02 6.76 4.02 14z",
    fill: "#c7c7c7"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#ebebeb",
    d: "M169.45 173.85h15.47v5.23h-15.47z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M164.45 223.02h25.48v9.27h-25.48zM317.89 190.92v40.66a5.14 5.14 0 01-5.14 5.14h-23.36a5.14 5.14 0 01-5.14-5.14v-40.66a5.13 5.13 0 015.14-5.12h.15v-2.45h23.06v2.45h.15a5.13 5.13 0 015.14 5.12z"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 286.39,
    y: 193.55,
    width: 29.36,
    height: 41.1,
    rx: 4.2,
    fill: "#a6a6a6"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#c7c7c7",
    d: "M286.14 178.32h29.73v4.89h-29.73z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#ebebeb",
    d: "M292.34 210.03h17.46v17.62h-17.46z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M152.41 290.91V314a2.93 2.93 0 01-2.93 2.92h-13.29a2.92 2.92 0 01-2.92-2.92v-23.09a2.92 2.92 0 012.92-2.92h.09v-1.39h13.11v1.4h.09a2.93 2.93 0 012.93 2.91z",
    fill: "#fff"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 134.48,
    y: 292.4,
    width: 16.7,
    height: 23.38,
    rx: 1.68,
    fill: "#ebebeb"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#a6a6a6",
    d: "M134.34 283.74h16.91v2.78h-16.91z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M152.32 257.72v23.13a2.93 2.93 0 01-2.92 2.93h-13.3a2.93 2.93 0 01-2.92-2.93v-23.13a2.91 2.91 0 012.92-2.91h.09v-1.4h13.12v1.4h.09a2.91 2.91 0 012.92 2.91z",
    fill: "#fff"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 134.4,
    y: 259.22,
    width: 16.7,
    height: 23.38,
    rx: 1.68,
    fill: "#ebebeb"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#a6a6a6",
    d: "M134.26 250.55h16.91v2.78h-16.91z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M172.66 290.91V314a2.93 2.93 0 01-2.93 2.92h-13.29a2.93 2.93 0 01-2.93-2.92v-23.09a2.93 2.93 0 012.93-2.92h.09v-1.39h13.11v1.4h.09a2.93 2.93 0 012.93 2.91z",
    fill: "#fff"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 154.73,
    y: 292.4,
    width: 16.7,
    height: 23.38,
    rx: 1.68,
    fill: "#ebebeb"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#a6a6a6",
    d: "M154.59 283.74h16.91v2.78h-16.91z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M172.57 257.72v23.13a2.93 2.93 0 01-2.92 2.93h-13.3a2.93 2.93 0 01-2.92-2.93v-23.13a2.91 2.91 0 012.92-2.91h.09v-1.4h13.12v1.4h.09a2.91 2.91 0 012.92 2.91z",
    fill: "#fff"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 154.65,
    y: 259.22,
    width: 16.7,
    height: 23.38,
    rx: 1.68,
    fill: "#ebebeb"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#a6a6a6",
    d: "M154.51 250.55h16.91v2.78h-16.91z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M192.91 290.91V314a2.93 2.93 0 01-2.91 3h-13.31a2.93 2.93 0 01-2.93-2.92v-23.17a2.93 2.93 0 012.93-2.92h.09v-1.39h13.11v1.4h.11a2.93 2.93 0 012.91 2.91z",
    fill: "#fff"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 174.98,
    y: 292.4,
    width: 16.7,
    height: 23.38,
    rx: 1.68,
    fill: "#ebebeb"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#a6a6a6",
    d: "M174.84 283.74h16.91v2.78h-16.91z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M192.82 257.72v23.13a2.93 2.93 0 01-2.92 2.93h-13.3a2.93 2.93 0 01-2.92-2.93v-23.13a2.91 2.91 0 012.92-2.91h.09v-1.4h13.12v1.4h.09a2.91 2.91 0 012.92 2.91z",
    fill: "#fff"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 174.9,
    y: 259.22,
    width: 16.7,
    height: 23.38,
    rx: 1.68,
    fill: "#ebebeb"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "#a6a6a6",
    d: "M174.76 250.55h16.91v2.78h-16.91z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M213.16 290.91V314a2.93 2.93 0 01-2.93 2.92h-13.29A2.93 2.93 0 01194 314v-23.09a2.93 2.93 0 012.93-2.92h.07v-1.39h13.11v1.4h.09a2.93 2.93 0 012.96 2.91z",
    fill: "#fff"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 195.23,
    y: 292.4,
    width: 16.7,
    height: 23.38,
    rx: 1.68,
    fill: "#ebebeb"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "#a6a6a6",
    d: "M195.09 283.74H212v2.78h-16.91z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M213.07 257.72v23.13a2.93 2.93 0 01-2.92 2.93h-13.3a2.93 2.93 0 01-2.92-2.93v-23.13a2.91 2.91 0 012.92-2.91h.09v-1.4h13.12v1.4h.09a2.91 2.91 0 012.92 2.91z",
    fill: "#fff"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 195.15,
    y: 259.22,
    width: 16.7,
    height: 23.38,
    rx: 1.68,
    fill: "#ebebeb"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "#a6a6a6",
    d: "M195.01 250.55h16.91v2.78h-16.91z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M233.41 290.91V314a2.93 2.93 0 01-2.93 2.92h-13.29a2.93 2.93 0 01-2.93-2.92v-23.09a2.93 2.93 0 012.93-2.92h.09v-1.39h13.11v1.4h.09a2.93 2.93 0 012.93 2.91z",
    fill: "#fff"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 215.48,
    y: 292.4,
    width: 16.7,
    height: 23.38,
    rx: 1.68,
    fill: "#ebebeb"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "#a6a6a6",
    d: "M215.34 283.74h16.91v2.78h-16.91z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M233.32 257.72v23.13a2.93 2.93 0 01-2.92 2.93h-13.3a2.93 2.93 0 01-2.92-2.93v-23.13a2.91 2.91 0 012.92-2.91h.09v-1.4h13.12v1.4h.09a2.91 2.91 0 012.92 2.91z",
    fill: "#fff"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 215.4,
    y: 259.22,
    width: 16.7,
    height: 23.38,
    rx: 1.68,
    fill: "#ebebeb"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "#a6a6a6",
    d: "M215.26 250.55h16.91v2.78h-16.91z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M253.66 290.91V314a2.93 2.93 0 01-2.93 2.92h-13.29a2.93 2.93 0 01-2.93-2.92v-23.09a2.93 2.93 0 012.93-2.92h.09v-1.39h13.11v1.4h.09a2.93 2.93 0 012.93 2.91z",
    fill: "#fff"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 235.73,
    y: 292.4,
    width: 16.71,
    height: 23.38,
    rx: 1.68,
    fill: "#ebebeb"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "#a6a6a6",
    d: "M235.59 283.74h16.91v2.78h-16.91z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M253.57 257.72v23.13a2.93 2.93 0 01-2.92 2.93h-13.3a2.93 2.93 0 01-2.92-2.93v-23.13a2.91 2.91 0 012.92-2.91h.09v-1.4h13.12v1.4h.09a2.91 2.91 0 012.92 2.91z",
    fill: "#fff"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 235.65,
    y: 259.22,
    width: 16.7,
    height: 23.38,
    rx: 1.68,
    fill: "#ebebeb"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "#a6a6a6",
    d: "M235.51 250.55h16.91v2.78h-16.91z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M273.9 290.91V314a2.92 2.92 0 01-2.9 3h-13.31a2.93 2.93 0 01-2.93-2.92v-23.17a2.93 2.93 0 012.93-2.92h.09v-1.39h13.11v1.4h.11a2.92 2.92 0 012.9 2.91z",
    fill: "#fff"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 255.98,
    y: 292.4,
    width: 16.7,
    height: 23.38,
    rx: 1.68,
    fill: "#ebebeb"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fill: "#a6a6a6",
    d: "M255.84 283.74h16.91v2.78h-16.91z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M273.82 257.72v23.13a2.93 2.93 0 01-2.92 2.93h-13.3a2.93 2.93 0 01-2.92-2.93v-23.13a2.91 2.91 0 012.92-2.91h.09v-1.4h13.12v1.4h.09a2.91 2.91 0 012.92 2.91z",
    fill: "#fff"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 255.9,
    y: 259.22,
    width: 16.7,
    height: 23.38,
    rx: 1.68,
    fill: "#ebebeb"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fill: "#a6a6a6",
    d: "M255.76 250.55h16.91v2.78h-16.91z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M355.15 190.92v40.66a5.14 5.14 0 01-5.14 5.14h-23.37a5.14 5.14 0 01-5.14-5.14v-40.66a5.13 5.13 0 015.14-5.12h.16v-2.45h23.05v2.45h.15a5.13 5.13 0 015.15 5.12z",
    fill: "#fff"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 323.64,
    y: 193.55,
    width: 29.36,
    height: 41.1,
    rx: 4.2,
    fill: "#a6a6a6"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fill: "#c7c7c7",
    d: "M323.39 178.32h29.73v4.89h-29.73z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fill: "#ebebeb",
    d: "M329.6 210.03h17.46v17.62H329.6z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M392.4 190.92v40.66a5.14 5.14 0 01-5.14 5.14H363.9a5.14 5.14 0 01-5.14-5.14v-40.66a5.13 5.13 0 015.14-5.12h.15v-2.45h23.06v2.45h.15a5.13 5.13 0 015.14 5.12z",
    fill: "#fff"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 360.9,
    y: 193.55,
    width: 29.36,
    height: 41.1,
    rx: 4.2,
    fill: "#a6a6a6"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fill: "#c7c7c7",
    d: "M360.65 178.32h29.73v4.89h-29.73z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fill: "#ebebeb",
    d: "M366.85 210.03h17.46v17.62h-17.46z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M429.66 190.92v40.66a5.14 5.14 0 01-5.14 5.14h-23.37a5.14 5.14 0 01-5.14-5.14v-40.66a5.13 5.13 0 015.14-5.12h.16v-2.45h23.05v2.45h.16a5.13 5.13 0 015.14 5.12z",
    fill: "#fff"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 398.15,
    y: 193.55,
    width: 29.36,
    height: 41.1,
    rx: 4.2,
    fill: "#a6a6a6"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fill: "#c7c7c7",
    d: "M397.9 178.32h29.73v4.89H397.9z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fill: "#ebebeb",
    d: "M404.11 210.03h17.46v17.62h-17.46z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fill: "#c7c7c7",
    d: "M277.5 251.89h46.14v64.97H277.5z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fill: "#a6a6a6",
    d: "M284.08 270.96h32.99v2.85h-32.99zM287.46 276.38h26.23v2.85h-26.23z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fill: "#ebebeb",
    d: "M287.46 261.01h26.23v2.85h-26.23z"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 300.57,
    cy: 297.38,
    rx: 17.93,
    ry: 10,
    fill: "#fff"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fill: "#c7c7c7",
    d: "M328.48 251.89h46.14v64.97h-46.14z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fill: "#a6a6a6",
    d: "M335.05 270.96h32.99v2.85h-32.99zM338.43 276.38h26.23v2.85h-26.23z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fill: "#ebebeb",
    d: "M338.43 261.01h26.23v2.85h-26.23z"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 351.55,
    cy: 297.38,
    rx: 17.93,
    ry: 10,
    fill: "#fff"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fill: "#c7c7c7",
    d: "M379.45 251.89h46.14v64.97h-46.14z"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fill: "#a6a6a6",
    d: "M386.02 270.96h32.99v2.85h-32.99zM389.4 276.38h26.23v2.85H389.4z"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fill: "#ebebeb",
    d: "M389.4 261.01h26.23v2.85H389.4z"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 402.52,
    cy: 297.38,
    rx: 17.93,
    ry: 10,
    fill: "#fff"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fill: "#ebebeb",
    d: "M246.55 391.4H214v-41.81h32.55z"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M242.47 370.29h-23.9v-8.91h23.9zM242.47 388.08h-23.9v-13.54h23.9z"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fill: "#c7c7c7",
    d: "M248.45 356.11H212.1v-6.52h36.35z"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fill: "#ebebeb",
    d: "M208.4 391.4h-32.55v-41.81h32.55z"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M204.31 370.29h-23.9v-8.91h23.9zM204.31 388.08h-23.9v-13.54h23.9z"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    fill: "#c7c7c7",
    d: "M210.3 356.11h-36.35v-6.52h36.35z"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    fill: "#ebebeb",
    d: "M284.7 391.4h-32.55v-41.81h32.55z"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M280.61 370.29h-23.9v-8.91h23.9zM280.61 388.08h-23.9v-13.54h23.9z"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    fill: "#c7c7c7",
    d: "M286.61 356.11h-36.35v-6.52h36.35z"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    fill: "#ebebeb",
    d: "M170.26 391.4h-32.55v-41.81h32.55z"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M166.17 370.29h-23.9v-8.91h23.9zM166.17 388.08h-23.9v-13.54h23.9z"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    fill: "#c7c7c7",
    d: "M172.16 356.11h-36.35v-6.52h36.35z"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M130.61 410.13h302.84v8.09H130.61z"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M332.65 159s-5.35-15.06-3.12-22.34c1.49-4.89 8.84-8.15 8.84-13.34v-5.65h6.35s11 23 1.86 41.33z",
    fill: "#ebebeb"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 336.97,
    y: 118.65,
    width: 7.93,
    height: 1.91,
    rx: 0.47,
    fill: "#ebebeb"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 336.97,
    y: 120.56,
    width: 7.93,
    height: 1.91,
    rx: 0.47,
    fill: "#ebebeb"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 336.97,
    y: 122.47,
    width: 7.93,
    height: 1.91,
    rx: 0.47,
    fill: "#ebebeb"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M333.87 109.45a4.7 4.7 0 01.95 2.86c-.14 1.45-.81 2.81-.58 2.89a4.46 4.46 0 002.44-3 4.63 4.63 0 00-.19-2.7z",
    fill: "#ebebeb"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M345.35 116.67v-3.91a2.15 2.15 0 012.12-1.8c2.35 0 5.2 2.79 5.34 1.84s-1.47-8-7-8h-13.14v4.67h2.67c.59 0 2.54.36 2.54 3.21v4z",
    fill: "#fff"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 337.09,
    y: 114.27,
    width: 9.04,
    height: 4.23,
    rx: 0.49,
    fill: "#c7c7c7"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    fill: "#c7c7c7",
    d: "M332.67 104.13v5.97l-2.44-.53v-4.91l2.44-.53z"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M341.62 127.51c4 0 6.35 5.69 6.35 13.4a51.28 51.28 0 01-1.36 11.46 2.63 2.63 0 01-2.57 2h-8.5a2.63 2.63 0 01-2.54-2c-1.06-4-3.06-13-.63-16.39 3.27-4.6 6.05-5.71 7.24-8.55z",
    fill: "#fff"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M383.34 159s-5.34-15-3.12-22.32c1.5-4.89 8.84-8.15 8.84-13.34v-5.65h6.36s11 23 1.86 41.33z",
    fill: "#ebebeb"
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 387.67,
    y: 118.65,
    width: 7.93,
    height: 1.91,
    rx: 0.47,
    fill: "#ebebeb"
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 387.67,
    y: 120.56,
    width: 7.93,
    height: 1.91,
    rx: 0.47,
    fill: "#ebebeb"
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 387.67,
    y: 122.47,
    width: 7.93,
    height: 1.91,
    rx: 0.47,
    fill: "#ebebeb"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M384.57 109.45a4.7 4.7 0 01.95 2.86c-.14 1.45-.81 2.81-.59 2.89a4.43 4.43 0 002.44-3 4.69 4.69 0 00-.18-2.7z",
    fill: "#ebebeb"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M396 116.67v-3.91a2.16 2.16 0 012.12-1.8c2.35 0 5.21 2.79 5.34 1.84s-1.46-8-7-8h-13.09v4.67H386c.59 0 2.53.36 2.53 3.21v4z",
    fill: "#fff"
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 387.79,
    y: 114.27,
    width: 9.04,
    height: 4.23,
    rx: 0.49,
    fill: "#c7c7c7"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    fill: "#c7c7c7",
    d: "M383.37 104.13v5.97l-2.44-.53v-4.91l2.44-.53z"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M392.31 127.51c4 0 6.35 5.69 6.35 13.4a50.68 50.68 0 01-1.36 11.46 2.63 2.63 0 01-2.56 2h-8.5a2.61 2.61 0 01-2.54-2c-1.06-4-3.07-13-.63-16.39 3.26-4.6 6.05-5.71 7.23-8.55z",
    fill: "#fff"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M408.69 159s-5.34-15.06-3.12-22.34c1.5-4.89 8.84-8.15 8.84-13.34v-5.65h6.36s11 23 1.86 41.33z",
    fill: "#ebebeb"
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 413.02,
    y: 118.65,
    width: 7.93,
    height: 1.91,
    rx: 0.47,
    fill: "#ebebeb"
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    x: 413.02,
    y: 120.56,
    width: 7.93,
    height: 1.91,
    rx: 0.47,
    fill: "#ebebeb"
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    x: 413.02,
    y: 122.47,
    width: 7.93,
    height: 1.91,
    rx: 0.47,
    fill: "#ebebeb"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M409.92 109.45a4.72 4.72 0 01.94 2.86c-.13 1.45-.8 2.81-.58 2.89a4.43 4.43 0 002.44-3 4.69 4.69 0 00-.18-2.7z",
    fill: "#ebebeb"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M421.39 116.67v-3.91a2.15 2.15 0 012.12-1.8c2.35 0 5.2 2.79 5.34 1.84s-1.47-8-7-8h-13.13v4.67h2.67c.59 0 2.53.36 2.53 3.21v4z",
    fill: "#fff"
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    x: 413.14,
    y: 114.27,
    width: 9.04,
    height: 4.23,
    rx: 0.49,
    fill: "#c7c7c7"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    fill: "#c7c7c7",
    d: "M408.72 104.13v5.97l-2.45-.53v-4.91l2.45-.53z"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M417.66 127.51c4 0 6.35 5.69 6.35 13.4a50.68 50.68 0 01-1.36 11.46 2.63 2.63 0 01-2.56 2h-8.51a2.63 2.63 0 01-2.54-2c-1.06-4-3.06-13-.63-16.39 3.27-4.6 6.06-5.71 7.24-8.55z",
    fill: "#fff"
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    x: 193.88,
    y: 213.85,
    width: 27.19,
    height: 24.15,
    rx: 4.56,
    fill: "#fff"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    fill: "#a6a6a6",
    d: "M196.96 210.82h21.03v3.02h-21.03z"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    fill: "#ebebeb",
    d: "M193.88 219.71h27.37v12.44h-27.37z"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M215.77 225.92c0 2.89-3.72 5.24-8.3 5.24s-8.29-2.35-8.29-5.24 3.71-5.23 8.29-5.23 8.3 2.31 8.3 5.23z",
    fill: "#fff"
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    x: 223.71,
    y: 213.85,
    width: 27.19,
    height: 24.15,
    rx: 4.56,
    fill: "#fff"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    fill: "#a6a6a6",
    d: "M226.79 210.82h21.03v3.02h-21.03z"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    fill: "#ebebeb",
    d: "M223.71 219.71h27.37v12.44h-27.37z"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M245.6 225.92c0 2.89-3.71 5.24-8.29 5.24s-8.3-2.35-8.3-5.24 3.72-5.23 8.3-5.23 8.29 2.31 8.29 5.23z",
    fill: "#fff"
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    x: 253.55,
    y: 213.85,
    width: 27.19,
    height: 24.15,
    rx: 4.56,
    fill: "#fff"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    fill: "#a6a6a6",
    d: "M256.63 210.82h21.03v3.02h-21.03z"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    fill: "#ebebeb",
    d: "M253.55 219.71h27.37v12.44h-27.37z"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M275.44 225.92c0 2.89-3.72 5.24-8.3 5.24s-8.29-2.35-8.29-5.24 3.71-5.23 8.29-5.23 8.3 2.31 8.3 5.23z",
    fill: "#fff"
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    x: 193.88,
    y: 186.04,
    width: 27.19,
    height: 24.15,
    rx: 4.56,
    fill: "#fff"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    fill: "#a6a6a6",
    d: "M196.96 183.01h21.03v3.02h-21.03z"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    fill: "#ebebeb",
    d: "M193.88 191.89h27.37v12.44h-27.37z"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M215.77 198.11c0 2.89-3.72 5.23-8.3 5.23s-8.29-2.34-8.29-5.23 3.71-5.23 8.29-5.23 8.3 2.34 8.3 5.23z",
    fill: "#fff"
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    x: 253.55,
    y: 186.04,
    width: 27.19,
    height: 24.15,
    rx: 4.56,
    fill: "#fff"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    fill: "#a6a6a6",
    d: "M256.63 183.01h21.03v3.02h-21.03z"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    fill: "#ebebeb",
    d: "M253.55 191.89h27.37v12.44h-27.37z"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M275.44 198.11c0 2.89-3.72 5.23-8.3 5.23s-8.29-2.34-8.29-5.23 3.71-5.23 8.29-5.23 8.3 2.34 8.3 5.23z",
    fill: "#fff"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    fill: "#ebebeb",
    d: "M400.38 332.5h10.2v12.28h-10.2z"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M427.94 386l-7.67-36.47a11.82 11.82 0 00-9.69-9.21 11.61 11.61 0 00-1.87-.16h-6.64a4.58 4.58 0 00-1.69.33 4.48 4.48 0 00-2.75 4.14V387a4.45 4.45 0 004.44 4.46h21.5a4.45 4.45 0 004.37-5.46zm-13.31-33.42a2.56 2.56 0 01.66-.07 3.13 3.13 0 013.06 2.46l3.22 14.59a3.13 3.13 0 01-6.12 1.32l-3.21-14.58a3.15 3.15 0 012.39-3.69z",
    fill: "#c7c7c7"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M403.5 346.22h3.93a2.44 2.44 0 012.37 3.14 15.63 15.63 0 00-.31 7.55c1.33 7.53 3.16 16.9 3.77 18.13.51 1 2.92 2.94 6.65 1.92a2.48 2.48 0 013.09 1.77l.83 3.45a2.46 2.46 0 01-2.39 3H403.5a2.46 2.46 0 01-2.46-2.46v-34.04a2.46 2.46 0 012.46-2.46z",
    fill: "#fff"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    fill: "#ebebeb",
    d: "M331.59 332.5h10.2v12.28h-10.2z"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M359.15 386l-7.67-36.47a11.82 11.82 0 00-9.69-9.21 11.61 11.61 0 00-1.87-.16h-6.63a4.59 4.59 0 00-1.7.33 4.5 4.5 0 00-2.75 4.14V387a4.45 4.45 0 004.45 4.46h21.5a4.45 4.45 0 004.36-5.46zm-13.31-33.42a2.63 2.63 0 01.67-.07 3.12 3.12 0 013.05 2.46l3.22 14.59a3.13 3.13 0 11-6.12 1.32l-3.21-14.58a3.15 3.15 0 012.39-3.69z",
    fill: "#c7c7c7"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M334.71 346.22h3.94a2.44 2.44 0 012.36 3.14 15.63 15.63 0 00-.31 7.55c1.33 7.53 3.16 16.9 3.77 18.13.51 1 2.92 2.94 6.65 1.92a2.48 2.48 0 013.09 1.77l.83 3.45a2.46 2.46 0 01-2.39 3h-17.94a2.46 2.46 0 01-2.46-2.46v-34.04a2.46 2.46 0 012.46-2.46z",
    fill: "#fff"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    fill: "#ebebeb",
    d: "M297.19 332.5h10.2v12.28h-10.2z"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M324.76 386l-7.67-36.47a11.82 11.82 0 00-9.69-9.21 11.61 11.61 0 00-1.87-.16h-6.64a4.68 4.68 0 00-1.7.33 4.49 4.49 0 00-2.74 4.14V387a4.45 4.45 0 004.44 4.46h21.5a4.46 4.46 0 004.37-5.46zm-13.32-33.42a2.63 2.63 0 01.67-.07 3.11 3.11 0 013.05 2.46l3.23 14.59a3.14 3.14 0 01-6.13 1.32l-3.2-14.58a3.14 3.14 0 012.38-3.69z",
    fill: "#c7c7c7"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M300.32 346.22h3.93a2.44 2.44 0 012.36 3.14 15.66 15.66 0 00-.3 7.55c1.32 7.53 3.16 16.9 3.77 18.13.51 1 2.92 2.94 6.65 1.92a2.47 2.47 0 013.08 1.77l.84 3.45a2.46 2.46 0 01-2.39 3h-17.94a2.46 2.46 0 01-2.46-2.46v-34.04a2.46 2.46 0 012.46-2.46z",
    fill: "#fff"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#92e3a9",
    d: "M365.98 332.5h10.2v12.28h-10.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.55 386l-7.67-36.47a11.82 11.82 0 00-9.69-9.21 11.61 11.61 0 00-1.87-.16h-6.64a4.68 4.68 0 00-1.7.33 4.5 4.5 0 00-2.75 4.14V387a4.46 4.46 0 004.45 4.46h21.5a4.46 4.46 0 004.37-5.46zm-13.32-33.42a2.63 2.63 0 01.67-.07A3.11 3.11 0 01384 355l3.23 14.59a3.14 3.14 0 01-6.13 1.32l-3.2-14.58a3.14 3.14 0 012.33-3.72z",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.11 346.22H373a2.44 2.44 0 012.36 3.14 15.66 15.66 0 00-.3 7.55c1.32 7.53 3.16 16.9 3.77 18.13.51 1 2.92 2.94 6.64 1.92a2.48 2.48 0 013.09 1.77l.84 3.45a2.46 2.46 0 01-2.39 3h-17.9a2.46 2.46 0 01-2.46-2.46v-34.04a2.46 2.46 0 012.46-2.46z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.44 405a43.06 43.06 0 1143.06-43 43.11 43.11 0 01-43.06 43zm0-84.12A41.06 41.06 0 10419.5 362a41.11 41.11 0 00-41.06-41.1z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.44 390.83A28.88 28.88 0 11407.32 362a28.91 28.91 0 01-28.88 28.83zm0-56.75A27.88 27.88 0 10406.32 362a27.92 27.92 0 00-27.88-27.92zM377.44 319.9h2v8.24h-2zM336.38 360.96h8.24v2h-8.24zM377.44 395.78h2v8.24h-2zM412.26 360.96h8.24v2h-8.24z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M374.32 361.46h8.24v1h-8.24z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M377.94 357.84h1v8.24h-1z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 223.71,
    y: 186.04,
    width: 27.19,
    height: 24.15,
    rx: 4.56,
    fill: "#92e3a9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 223.71,
    y: 186.04,
    width: 27.19,
    height: 24.15,
    rx: 4.56,
    fill: "#fff",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#37474f",
    d: "M226.79 183.01h21.03v3.02h-21.03z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#92e3a9",
    d: "M223.71 191.89h27.37v12.44h-27.37z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.6 198.11c0 2.89-3.71 5.23-8.29 5.23S229 201 229 198.11s3.72-5.23 8.3-5.23 8.3 2.34 8.3 5.23z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.4 239.66a43.07 43.07 0 1143.06-43.06 43.12 43.12 0 01-43.06 43.06zm0-84.13a41.07 41.07 0 1041.06 41.07 41.12 41.12 0 00-41.06-41.07z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.4 225.47a28.88 28.88 0 1128.87-28.87 28.9 28.9 0 01-28.87 28.87zm0-56.75a27.88 27.88 0 1027.87 27.88 27.91 27.91 0 00-27.87-27.88zM236.4 154.53h2v8.24h-2zM195.33 195.6h8.24v2h-8.24zM236.4 230.42h2v8.24h-2zM271.22 195.6h8.24v2h-8.24z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M233.28 196.1h8.24v1h-8.24z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M236.9 192.48h1v8.24h-1z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M358 159s-5.35-15.06-3.12-22.34c1.49-4.89 8.84-8.15 8.84-13.34v-5.65h6.35s11 23 1.86 41.33z",
    fill: "#92e3a9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 362.32,
    y: 118.65,
    width: 7.93,
    height: 1.91,
    rx: 0.47,
    fill: "#92e3a9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 362.32,
    y: 120.56,
    width: 7.93,
    height: 1.91,
    rx: 0.47,
    fill: "#92e3a9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 362.32,
    y: 122.47,
    width: 7.93,
    height: 1.91,
    rx: 0.47,
    fill: "#92e3a9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.22 109.45a4.7 4.7 0 01.95 2.86c-.14 1.45-.81 2.81-.59 2.89a4.41 4.41 0 002.44-3 4.69 4.69 0 00-.18-2.7z",
    fill: "#92e3a9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.69 116.67v-3.91a2.16 2.16 0 012.12-1.8c2.35 0 5.21 2.79 5.34 1.84s-1.46-8-7-8H358v4.67h2.67c.59 0 2.53.36 2.53 3.21v4z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 362.44,
    y: 114.27,
    width: 9.04,
    height: 4.23,
    rx: 0.49,
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M358.02 104.13v5.97l-2.44-.53v-4.91l2.44-.53z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367 127.51c4 0 6.36 5.69 6.36 13.4a50.57 50.57 0 01-1.36 11.46 2.61 2.61 0 01-2.56 2h-8.5a2.62 2.62 0 01-2.54-2c-1.06-4-3.07-13-.63-16.39 3.26-4.6 6-5.71 7.23-8.55z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.25 174.64a43.07 43.07 0 1143.06-43.06 43.12 43.12 0 01-43.06 43.06zm0-84.13a41.07 41.07 0 1041.06 41.07 41.12 41.12 0 00-41.06-41.07z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.25 160.45a28.88 28.88 0 1128.87-28.87 28.91 28.91 0 01-28.87 28.87zm0-56.75a27.88 27.88 0 1027.87 27.88 27.92 27.92 0 00-27.87-27.88zM365.25 89.51h2v8.24h-2zM324.18 130.58h8.24v2h-8.24zM365.25 165.4h2v8.24h-2zM400.07 130.58h8.24v2h-8.24z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M362.13 131.08h8.24v1h-8.24z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M365.75 127.46h1v8.24h-1z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M329.82 442.88H208.87a2.42 2.42 0 01-2.42-2.42V426v-.13a2 2 0 010-.26l14.62-53.7-19-117.4-26.45-8.95a2.41 2.41 0 111.36-4.63l28.02 9.41a2.4 2.4 0 011.71 1.95L226 371.63a2.46 2.46 0 010 .81l-14.19 51.45 112.67 8a2.51 2.51 0 011.64.79l5.55 6.15a2.42 2.42 0 01-1.79 4zM211.28 438h113.1l-1.25-1.38-111.85-8z",
    fill: "#a6a6a6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.92 244.31l-28.45-9.53c-6.88-2.3-9.83 8.56-3 10.85l28.45 9.52c6.88 2.31 9.83-8.55 3-10.84z",
    fill: "#92e3a9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.71 354.14H221.33a.81.81 0 110-1.61h127.38a.81.81 0 110 1.61zM352 344.35H219.83a.81.81 0 110-1.61H352a.81.81 0 010 1.61zM355 334.55H218.33a.81.81 0 110-1.61H355a.81.81 0 010 1.61zM358.19 324.75H216.83a.81.81 0 110-1.61h141.36a.81.81 0 110 1.61zM361.29 315h-146a.81.81 0 110-1.61h146a.81.81 0 110 1.61zM364.61 305.16H213.83a.81.81 0 010-1.62h150.78a.81.81 0 010 1.62zM367.78 295.36H212.33a.81.81 0 110-1.61h155.45a.81.81 0 110 1.61z",
    fill: "#a6a6a6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.56 366.43a.8.8 0 01-.8-.74L227.59 285a.8.8 0 01.74-.86.84.84 0 01.87.74l6.17 80.7a.82.82 0 01-.75.87zM334.44 361.17a.76.76 0 01-.21 0 .81.81 0 01-.57-1l20.51-75.44a.81.81 0 011.56.42l-20.52 75.44a.8.8 0 01-.77.58zM247.43 365.83a.81.81 0 01-.8-.78l-2-80.11a.8.8 0 01.79-.82.81.81 0 01.8.78l2 80.1a.81.81 0 01-.79.83zM260.64 365.12a.81.81 0 01-.79-.82l1.48-79.39a.81.81 0 01.81-.79.8.8 0 01.79.82l-1.48 79.39a.8.8 0 01-.81.79zM320.38 361.8h-.17a.8.8 0 01-.62-.95l15.58-76.07a.81.81 0 111.58.33l-15.58 76.07a.81.81 0 01-.79.62zM304.36 362.76h-.13a.81.81 0 01-.66-.93l12.62-77a.8.8 0 011.58.26l-12.61 77a.81.81 0 01-.8.67zM274.16 364.35h-.06a.81.81 0 01-.75-.86l5.89-78.63a.8.8 0 011.6.12L275 363.61a.8.8 0 01-.84.74zM290 363.32h-.09a.81.81 0 01-.71-.89l8.63-77.6a.8.8 0 01.89-.71.81.81 0 01.71.89l-8.63 77.6a.79.79 0 01-.8.71z",
    fill: "#a6a6a6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.11 287.34h-163a2.42 2.42 0 110-4.83h163a2.42 2.42 0 110 4.83z",
    fill: "#a6a6a6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.57 367.46a.82.82 0 01-.81-.77.8.8 0 01.76-.84L346 359.29l24.12-74.61a.8.8 0 011.53.49l-24.29 75.15a.81.81 0 01-.72.55l-123 6.59z",
    fill: "#a6a6a6"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 224.03,
    cy: 445.25,
    r: 9.51,
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.35 445.25a4.32 4.32 0 11-4.32-4.32 4.32 4.32 0 014.32 4.32z",
    fill: "#a6a6a6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.58 445.25a9.51 9.51 0 11-9.5-9.51 9.5 9.5 0 019.5 9.51z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.4 445.25a4.32 4.32 0 11-4.32-4.32 4.32 4.32 0 014.32 4.32z",
    fill: "#a6a6a6"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M51.14 387.49l-1.07 42.34c0 7.83.19 14.68.6 18.22a.13.13 0 000 .06 5.43 5.43 0 00.58 2.42h.05c2.33 1.57 64.85 3.2 67.05 2.52s.44-7-1.94-9-26-13.32-26-13.32l.68-42.3z",
    fill: "#d3766a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50 421.44l.07 8.39c0 7.83.19 14.68.6 18.22a.13.13 0 000 .06 11.12 11.12 0 00.58 2.42h.05c2.33 1.57 64.85 3.2 67.05 2.52s.44-7-1.94-9-26-13.32-26-13.32l.05-8.53z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.21 430.79c-4.16-.69-9.22.06-12.33 3.08-.12.12.05.29.18.24a59.36 59.36 0 0112.15-2.8.26.26 0 000-.52zM97.24 432.53c-4.16-.69-9.22.06-12.33 3.08-.12.12 0 .29.19.24a59.11 59.11 0 0112.14-2.8.26.26 0 000-.52zM100.27 434.27c-4.16-.69-9.22.06-12.32 3.08-.12.12 0 .29.18.24a59.11 59.11 0 0112.14-2.8.26.26 0 000-.52z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.36 453.09c-2.2.68-64.72-.94-67-2.52-.9-.58-1.2-9.7-1.24-20.73v-.35l40.35.6v.68s23.65 11.32 26 13.33 4.09 8.32 1.89 8.99z",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.07 429.48v.36c0 11 .33 20.15 1.24 20.73s14.6 1.44 29.25 2c17.52.62 36.6.93 37.8.56 2.2-.68.43-7-1.94-9s-26-13.32-26-13.32v-.68L77 429.89z",
    fill: "#92e3a9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.71 450.65c-10.53-.53-53-1.69-63.5-1.41-.09 0-.09.06 0 .06 10.42.76 53 1.57 63.5 1.52.22 0 .23-.16 0-.17z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77 429.89c1 6.76 2.49 16.71 3.6 22.65 17.52.62 36.6.93 37.8.56 2.2-.68.43-7-1.94-9s-26-13.32-26-13.32v-.68z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.43 430.07l45.24.43s2.57-73.66 2.76-98.22c.23-28.06-1.36-112.22-1.36-112.22H59.24s-9.07 18.55-3.89 39.42l1.44 75.09z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.79 422.14a33.16 33.16 0 013.6-.28c1.34-.1 2.67-.2 4-.25 2.57-.11 5.15-.16 7.72-.17 5.2 0 10.39 0 15.58.19 3 .09 5.91.2 8.86.37a.1.1 0 010 .19c-5.15.19-10.31.27-15.46.37s-10.3.2-15.44.1c-1.48 0-2.95 0-4.43-.13s-3 0-4.42-.21c-.08-.01-.12-.16-.01-.18zM88.41 381.49c.53-12.18.92-24.37 1.25-36.55q1-36.57.53-73.14c-.17-13.68-.54-27.35-.94-41 0-.15.23-.14.24 0 1.29 24.48 1.78 49 1.81 73.51s-.48 48.77-1.68 73.13c-.68 13.66-1.51 27.34-2.8 41 0 .11-.19.11-.18 0 .55-12.36 1.24-24.65 1.77-36.95z",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.53 394.21l.35 40.93c0 7.82.19 14.68.6 18.22a.13.13 0 000 .06 5.37 5.37 0 00.58 2.41l.05.05c2.33 1.57 64.85 3.19 67 2.52s.44-7-1.94-9-26-13.33-26-13.33l-.73-40.88z",
    fill: "#d3766a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.81 426.74l.07 8.4c0 7.82.19 14.68.6 18.22a.13.13 0 000 .06 10.78 10.78 0 00.58 2.41l.05.05c2.33 1.57 64.85 3.19 67 2.52s.44-7-1.94-9-26-13.33-26-13.33v-8.52z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144 436.1c-4.16-.69-9.22.06-12.33 3.08-.12.11.05.28.18.24a58.07 58.07 0 0112.15-2.8.26.26 0 000-.52zM147.05 437.84c-4.16-.69-9.22.06-12.33 3.08-.12.11.05.28.19.24a57.84 57.84 0 0112.14-2.8.26.26 0 000-.52zM150.08 439.58c-4.16-.69-9.22.06-12.32 3.08-.12.11 0 .28.18.24a57.84 57.84 0 0112.14-2.8.26.26 0 000-.52z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.17 458.4c-2.2.68-64.72-.95-67-2.52-.9-.58-1.2-9.71-1.24-20.74v-.34l40.35.59v.69s23.65 11.32 26 13.32 4.09 8.33 1.89 9z",
    fill: "#92e3a9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.52 456c-10.53-.54-53.05-1.69-63.5-1.42-.09 0-.09.06 0 .07 10.42.76 53 1.56 63.5 1.52.22-.04.23-.17 0-.17zM78.87 263.36s18.55 58.49 18.89 69.24c.29 9.17-.89 103.22-.89 103.22l47 .28s-4-95.91-4.7-105.47c-1.37-17.86-17-66.89-28.21-110.57H60.29s.45 22.88 10.85 39.42c0 0 4.71 2.18 7.73 3.88z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.37 427.16c5.43-.16 11-.32 16.48-.19s10.78.22 16.16.54c3.05.18 6.09.28 9.14.59a.08.08 0 010 .16c-5.42.31-10.87.25-16.3.2s-10.77-.1-16.16-.35c-3.05-.14-6.09-.3-9.14-.51-.34-.02-.55-.43-.18-.44zM109.64 247.62c1.68 5.59 3.09 11.26 4.59 16.9s3 11.37 4.51 17.06c2.9 11 5.76 22 7.93 33.2a200.49 200.49 0 013.76 34c.25 11.65 0 23.31-.08 35s-.17 23.42-.38 35.12c0 1.46-.05 2.92-.11 4.37a.1.1 0 01-.21 0c-.32-11.65-.15-23.32-.11-35s.19-23.31.09-35a208.82 208.82 0 00-3-34.5c-2-11.21-4.72-22.26-7.59-33.27-1.63-6.28-3.28-12.56-4.91-18.84s-3.39-12.63-4.84-19a.18.18 0 01.35-.04zM90.48 264.49a41.72 41.72 0 01-7-.63 68.32 68.32 0 01-6.73-1.86 52.94 52.94 0 00-6.63-1.08 23.27 23.27 0 01-6.49-1.92c-.1 0-.18.1-.09.15a41.87 41.87 0 006.23 2.7c2.23.7 4.56.8 6.82 1.35a56.89 56.89 0 007 1.6 25 25 0 007-.12c.01-.05-.02-.19-.11-.19z",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.45 311c-.45-1.73-.87-3.47-1.34-5.2-1-3.49-1.91-7-3-10.45-2.09-6.88-4.07-13.8-6.29-20.64-1.26-3.88-2.39-7.81-3.86-11.62a.08.08 0 00-.15.05c.74 3.55 1.79 7 2.73 10.52s1.94 7 3 10.45c2 6.91 4 13.83 6.16 20.69.61 1.92 1.24 3.84 1.9 5.74s1.21 4 2 5.85a.08.08 0 10.16-.05c-.3-1.78-.86-3.55-1.31-5.34z",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.33 162.36c7.71 4.65 37 20.44 49.29 18.37 8.27-1.39 28.71-21 32.46-27.61 1.53-2.7-18-18.79-20.77-16.93-3 2-16.46 20.51-18.83 21.23s-24.47-2.79-37.27-3.26c-7.66-.27-9.21 5.58-4.88 8.2z",
    fill: "#d3766a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.58 158.7c4.28-3.76 15.48-20 17-23.65s5-14.59 2.32-16-4 1.68-4 1.68.91-5.28-2.09-6c-2.39-.6-4.44 3.69-4.44 3.69s.7-5.85-2.37-6.21c-2.8-.33-3.84 4.85-3.84 4.85s.08-5-2.67-4.75c-3.32.24-3.47 8.81-5.42 12.76-.45.89-16.93 18.21-16.93 18.21z",
    fill: "#d3766a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177 116.83c-.77 6.4-1.27 9-4.69 14.21-.06.1.07.23.15.13 3.81-4.77 4.63-7.85 4.84-14.35-.04-.32-.3-.29-.3.01zM183.29 118.38c-.7 6.54-2 9.4-5.2 15.09 0 .08.09.17.14.09 3.59-5.32 5.44-8.58 5.28-15.2-.01-.3-.18-.27-.22.02zM189.73 121c-1.14 6.27-2.33 9.6-6.12 14.72a.12.12 0 10.18.15c4.37-4.85 5.89-9 6.12-14.82.02-.4-.11-.45-.18-.05z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.12 143.23s3-6.83 4.33-10.14 3.62-13.17 6.55-14c3.28-1 4.05 8.22 1.81 14.15 0 0 8.24 6.35 6.35 12.15-.41 1.25-4.86 6.38-6.36 6.62z",
    fill: "#d3766a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.79 133.88c3.3 2.36 6.55 6.6 6.31 10.64a.09.09 0 00.18 0c.85-4.29-2.87-9.23-5.94-11.16-.59-.36-1.4-.09-.55.52z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.11 143.07l22.83 15.61s.53 3.21-3 6.61-18.6 16.1-26.35 16.32-33.66-9.44-46.3-17.61.72-10.52 3.5-10.33 35.7 3 36.69 2.64 5.68-7.74 8.18-10.41 4.45-2.83 4.45-2.83z",
    fill: "#92e3a9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.45 156.61a2.26 2.26 0 00-.28.5h.05a7.9 7.9 0 002.1.78 7.89 7.89 0 00-1.87-1.28zm53 2.57a8.47 8.47 0 00-2.11-.78 7.93 7.93 0 001.83 1.3 8.47 8.47 0 002.11.78 7.93 7.93 0 00-1.82-1.3zm-20.67 16.26a7.57 7.57 0 00-2.1-.78 8.69 8.69 0 003.93 2.07 7.89 7.89 0 00-1.82-1.29zm18.43 2.61a8.26 8.26 0 00-2.1-.78 7.93 7.93 0 001.83 1.3 8.26 8.26 0 002.1.78 7.93 7.93 0 00-1.82-1.3zm-8-9.83a7.57 7.57 0 00-.78 2.1 7.6 7.6 0 001.29-1.83 7.51 7.51 0 00.78-2.11 8.26 8.26 0 00-1.24 1.84zm-20.11-11.63a8 8 0 00-2 .93 7.76 7.76 0 002.21-.38 8.3 8.3 0 002-.93 7.7 7.7 0 00-2.16.38zm36.07-9.05a7.68 7.68 0 00-.94-2 8.61 8.61 0 001.32 4.25 8.06 8.06 0 00-.33-2.25zm.73 22.69a8.3 8.3 0 00-.93-2 7.83 7.83 0 00.38 2.22 8.07 8.07 0 00.93 2 7.82 7.82 0 00-.28-2.22zm-49-16.35h-.58a6.63 6.63 0 00.79 1.63 6.84 6.84 0 00-.11-1.63zm29.68 3.39a7.51 7.51 0 00-2.11-.78 8.79 8.79 0 003.94 2.07 7.6 7.6 0 00-1.74-1.29zm-25.24 5.14a7.57 7.57 0 00-2.1-.78 7.89 7.89 0 001.83 1.29 7.57 7.57 0 002.1.78 7.89 7.89 0 00-1.74-1.29zm51.55-2a8.26 8.26 0 00-.78 2.1 7.72 7.72 0 001.3-1.83 8.26 8.26 0 00.78-2.1 7.93 7.93 0 00-1.19 1.81zm6.49 8.32a4.49 4.49 0 00.64 0l.8-.68a7.18 7.18 0 00-1.35.66zm4.37-10.9a7.81 7.81 0 00-.79-1.78 1.2 1.2 0 00-.15-.24.76.76 0 000 .15 8.24 8.24 0 00.37 2.06 8 8 0 00.94 2 7.83 7.83 0 00-.28-2.21zm-48.9 7.72a7.75 7.75 0 00-.78 2.11 7.46 7.46 0 001.29-1.84 7.57 7.57 0 00.78-2.1 8.2 8.2 0 00-1.2 1.81z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.11 143.07l22.83 15.61s.53 3.21-3 6.61-18.6 16.1-26.35 16.32-33.66-9.44-46.3-17.61.72-10.52 3.5-10.33 35.7 3 36.69 2.64 5.68-7.74 8.18-10.41 4.45-2.83 4.45-2.83z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.68 234.69c.14.18 67.33 4.3 68 3.65.91-.92-11.34-71.34-15.33-82-1.69-4.53-12.38-6.54-17.16-3.09-12 8.63-23.61 40.07-26.43 49.58-4.7 15.7-9.6 31.17-9.08 31.86z",
    fill: "#92e3a9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.45 156.61a7.57 7.57 0 00-2.1-.78 8.69 8.69 0 003.93 2.07 7.89 7.89 0 00-1.83-1.29zm-7.36 38.27a7.57 7.57 0 00-2.1-.78 8.69 8.69 0 003.93 2.07 8.2 8.2 0 00-1.83-1.29zm6.47 28.61a7.9 7.9 0 00-2.1-.78 8.69 8.69 0 003.93 2.07 8.2 8.2 0 00-1.83-1.29zm-22.88-43.82A8.22 8.22 0 0069 179a1.3 1.3 0 00-.08.17 8 8 0 001.55 1 7.57 7.57 0 002.1.78 7.74 7.74 0 00-1.89-1.28zm40 26.93a7.84 7.84 0 00-2.11-.78 7.65 7.65 0 001.84 1.29 7.57 7.57 0 002.1.78 8.2 8.2 0 00-1.82-1.29zm-37.8 14.2a7.57 7.57 0 00-2.1-.78 8.69 8.69 0 003.93 2.07 7.6 7.6 0 00-1.83-1.29zm32.57-40.36a7.57 7.57 0 00-2.1-.78 8.69 8.69 0 003.93 2.07 8.2 8.2 0 00-1.83-1.29zm-6.31-12.63a7.57 7.57 0 00-.78 2.1 8.69 8.69 0 002.07-3.93 7.6 7.6 0 00-1.29 1.83zm10.46 59.27a7.57 7.57 0 00-.78 2.1 8.66 8.66 0 002.07-3.94 7.85 7.85 0 00-1.29 1.84zm-25-13.7a8.19 8.19 0 00-.78 2.11 8 8 0 001.3-1.84 8.26 8.26 0 00.78-2.1 7.93 7.93 0 00-1.33 1.83zm13-23.89a7.57 7.57 0 00-.78 2.1 8.69 8.69 0 002.07-3.93 7.89 7.89 0 00-1.33 1.83zm-37.05 37a8.26 8.26 0 00-.78 2.1 7.93 7.93 0 001.3-1.83 8.26 8.26 0 00.78-2.1 7.93 7.93 0 00-1.34 1.85zm2.89-28.1a7.57 7.57 0 00-.78 2.1 7.89 7.89 0 001.29-1.83 7.75 7.75 0 00.78-2.11 7.74 7.74 0 00-1.33 1.86zm13-29.94a8.26 8.26 0 00-.78 2.1 7.93 7.93 0 001.3-1.83 8.26 8.26 0 00.78-2.1 7.93 7.93 0 00-1.36 1.85zm9.76-5.53a7.83 7.83 0 00-2 .94 8.45 8.45 0 002.21-.38 7.68 7.68 0 002-.94 7.76 7.76 0 00-2.27.4zm15.59 52.47a7.83 7.83 0 00-2 .94 8.45 8.45 0 002.21-.38 7.68 7.68 0 002-.94 7.76 7.76 0 00-2.27.4zM73.3 235.46a8.65 8.65 0 00-1.49.61h.42l.77.05c.16-.05.28-.1.44-.14a8 8 0 002-.94 7.77 7.77 0 00-2.14.42zm.88-27.92a8 8 0 00-2 .93 8.61 8.61 0 004.25-1.32 8.07 8.07 0 00-2.25.39zM83.4 184a7.68 7.68 0 00-2 .94 8.07 8.07 0 002.21-.39 7.35 7.35 0 002-.93 7.7 7.7 0 00-2.21.38zm27.06 10.22a8.14 8.14 0 00-.93-2 7.7 7.7 0 00.38 2.21 8 8 0 00.93 2 7.76 7.76 0 00-.38-2.23zm-26.29 35.35a7.77 7.77 0 00-.94-2 8.6 8.6 0 00.38 2.21 7.77 7.77 0 00.94 2 7.82 7.82 0 00-.38-2.21zM61.28 212.8a8 8 0 00-.93-2 7.76 7.76 0 00.38 2.21 8 8 0 00.93 2 7.7 7.7 0 00-.38-2.21zm12.25-18.28a7.83 7.83 0 00-.94-2 8.45 8.45 0 00.38 2.21 7.68 7.68 0 00.94 2 7.76 7.76 0 00-.38-2.21zm26 40.55a8.17 8.17 0 00-.94-2 8.61 8.61 0 001.32 4.25 8.53 8.53 0 00-.35-2.25zm-3.65-30.94a8.54 8.54 0 00-.94-2 8.61 8.61 0 001.32 4.25 8.53 8.53 0 00-.35-2.25zm-4-28.52a7.68 7.68 0 00-.94-2 8.45 8.45 0 00.38 2.21 7.68 7.68 0 00.94 2 7.7 7.7 0 00-.39-2.21z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.6 157.51c0 3.06-.19 10.14-5 9.42a10.21 10.21 0 01-5-2.87 27.2 27.2 0 01-3.8-4.36 39.45 39.45 0 01-3.46-5.51c0-.09-.16 0-.12.07 1 1.93 1.85 3.93 3 5.76a23.37 23.37 0 004.1 4.82 10.16 10.16 0 005.33 2.84 3.87 3.87 0 004.1-2.67 17 17 0 00.85-7.5z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.06 163.7c-3.46.13-8.78-6.61-10.21-11.15-.1-.31.92-3.18 2-6.74.65-2.15 1.31-4.57 1.75-6.82l13.4 6.22a36.46 36.46 0 00-3.07 8.37 5.23 5.23 0 00-.09.94 1 1 0 010 .16c-.06 1.81-.44 8.89-3.78 9.02z",
    fill: "#d3766a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.85 154.52a.86.86 0 010 .15 9.09 9.09 0 01-1.46-.2c-8.13-1.8-8.07-12.17-7.89-15.06l3.34 1.59 9.17 4.24a36.46 36.46 0 00-3.07 8.37 5.23 5.23 0 00-.09.91z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.09 126.82c-.39 5.42 5.63 19.48 10 21.93 6.31 3.55 15 2.05 17.58-5.16 2.52-7-5.65-25.16-10.36-27.22-6.95-3.02-16.64 2.43-17.22 10.45z",
    fill: "#d3766a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.21 136.23c2.06 5.44 5.26 11.06 7.86 12.52 6.31 3.55 15 2.05 17.59-5.16.92-2.58.4-6.66-.87-10.9 0 .21.18 3.49-1.53 4.26a2.58 2.58 0 01-3-.62h-1.27a8.87 8.87 0 01-5.52 3 10.46 10.46 0 01-8.47-2.12c-1.59-1.44-1.72-2.13-1.72-2.13z",
    fill: "#263238",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.86 132.73v.12c.43.94.76 2.08 0 2.76 0 0 0 .06 0 0 1.02-.54.56-2.06 0-2.88z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.6 132.1c-1.58.53-.4 3.64 1.06 3.15s.26-3.59-1.06-3.15zM100.83 130.39a12.86 12.86 0 001-.88 2.14 2.14 0 00.89-1.1.7.7 0 00-.4-.75 1.74 1.74 0 00-1.71.45 2.54 2.54 0 00-1 1.56.75.75 0 001.22.72zM111.15 128.48a12.54 12.54 0 01-1.36.14 2.19 2.19 0 01-1.41-.11.71.71 0 01-.27-.82 1.76 1.76 0 011.51-.92 2.61 2.61 0 011.81.36.76.76 0 01-.28 1.35zM106.74 141.9a1.58 1.58 0 001 .26 2.83 2.83 0 00.94-.63h.06a1.38 1.38 0 01-1 1 1.1 1.1 0 01-1.07-.57s.03-.08.07-.06z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.67 138.63a3.51 3.51 0 002.74.64 4.68 4.68 0 001.2-.39l.21-.11.2-.12a.23.23 0 00.11-.28.24.24 0 000-.1v-.09c-.26-.75-.76-1.85-.76-1.85.32 0 1.94.14 1.77-.24a52.21 52.21 0 00-5-9.45.09.09 0 00-.16.09c1.23 3.07 3 5.9 4.27 9a6.38 6.38 0 00-1.73.11c-.09.07 1 2.11 1.09 2.46a4.88 4.88 0 01-3.8.22c-.18-.03-.23.06-.14.11z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.13 138.89a4.07 4.07 0 01-1.19 1.68 1.82 1.82 0 01-1 .39c-.83 0-1.06-.67-1.11-1.32a4.62 4.62 0 01.07-1 5.29 5.29 0 003.23.25z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.94 140.57a1.82 1.82 0 01-1 .39c-.83 0-1.06-.67-1.11-1.32a1.91 1.91 0 012.11.93z",
    fill: "#ff98b9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.91 129a3.41 3.41 0 00-.81.29 3.29 3.29 0 00-.72.52 2.51 2.51 0 00-.52.76 1.94 1.94 0 00-.15.95v.59l.47-.37a5.68 5.68 0 011.05-.67 2.59 2.59 0 011.25-.29 1.88 1.88 0 00-1.4-.14 3.58 3.58 0 00-1.29.62l.5.22a2.16 2.16 0 01.45-1.33 6.87 6.87 0 011.17-1.15z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.75 131.91a5.07 5.07 0 01-1.33.27c-.11 0-.55 0-.57-.1a2.58 2.58 0 01-.15-.65 1.56 1.56 0 000 .71.89.89 0 00.7.25 2.83 2.83 0 001.35-.48zM92.27 138.16c2.72-.88.7-7.58.7-7.58s4-1.86 4.59-8.2c0 0 6.32 2 10.66 0 6.81-3.16 4.21-12.4 1-13.59-4.49-1.7-10.22 4-10.22 4s-11-.19-12.21 7.52a5.41 5.41 0 00-3.51 6.5c1.03 5.06 6.95 12.01 8.99 11.35z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.18 131.63a9.68 9.68 0 004.58-4.31 7.24 7.24 0 000-6.67c-.06-.11.12-.2.18-.09a8.33 8.33 0 01.62 7.07 6.76 6.76 0 01-5.31 4.2.11.11 0 01-.07-.2zM82.19 123.9c.94-2.15 3-3 5.16-3.46.12 0 .16.17 0 .19a6.08 6.08 0 00-4.54 4.24c-.63 1.95.16 4 1.07 5.74a15.43 15.43 0 008.23 7.31v.09a15.35 15.35 0 01-9.17-8c-.86-1.81-1.62-4.13-.75-6.11zM98.84 113.15a7.25 7.25 0 013.15-4 8.64 8.64 0 016.08-.94 4.87 4.87 0 013.52 3.38 8.6 8.6 0 01-.5 5.76c0 .05-.1 0-.08 0a8.62 8.62 0 00.22-5.17 4.51 4.51 0 00-3.56-3.18c-3.27-.54-7.5.79-8.65 4.28a.1.1 0 01-.18-.13z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94 138.05s-4.48-3.89-6.33-2.19 2.34 7.94 5.08 8.25a2.64 2.64 0 003.09-2.23z",
    fill: "#d3766a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.87 137.62v.07c1.94.28 3.28 1.68 4.35 3.21a1.46 1.46 0 00-2.22.1.05.05 0 00.07.08 1.64 1.64 0 011.87.12 8.3 8.3 0 011.17 1.2c.13.13.39 0 .28-.19-.52-2.21-3.05-4.96-5.52-4.59zM151.18 133.72l-40.44 3.25-1.2-9.15 39.9-7.35 1.74 13.25z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#37474f",
    d: "M174.18 134.46l-40.59 2.1-1.88-14.27 39.74-8.5 2.73 20.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M193.94 136.74l-31.11-.67-2.76-20.89 29.88-8.72 3.99 30.28z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194 121.33c1 7.63.89 13.94-.25 14.1s-2.89-5.92-3.9-13.56-.89-14 .25-14.1 2.9 5.92 3.9 13.56z",
    fill: "#92e3a9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.18 172.14c13.55 12.51 48.56 32.22 55.79 28.7 13.32-6.49 16-46.05 17.24-53.78.54-3.3-27.6-3.66-28.24-.15-.56 3.06-.48 23.76-3 24.67-1 .38-16.79-4.86-34.47-7.7-13.5-2.18-11.32 4.56-7.32 8.26z",
    fill: "#d3766a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.55 153.33s.48-3.25-.71-11.18c-.93-6.2 1.2-21.41 16.25-30.56 5.76-3.51 10.74-1 5.4 3.71-3.77 3.32-6.66 5.29-7.58 6.72 0 0 7.66-.39 10.42 3.1a81.57 81.57 0 016.54 9.65 17.44 17.44 0 01-1.69 1.38 9.35 9.35 0 01.17 10l-.88 6.8z",
    fill: "#d3766a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.72 136.58c1.7-2.81 5.4-8.7 10.11-12.47 5.23-4.19 16.43-10.84 19.48-7 2.23 2.85-1.82 5.77-1.82 5.77s5.21-1.77 6.67 1.25c1.32 2.75-1.95 4.81-1.95 4.81s3.35-.53 4.12 2.37c.92 3.48-6.24 4-8.35 8.37-.48 1.02-28.26-3.1-28.26-3.1z",
    fill: "#d3766a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.33 130.37a26.68 26.68 0 0114-7.49c.14 0 .23.07.11.11a65.78 65.78 0 00-14.1 7.43s-.03-.02-.01-.05zM151.71 135.53c2-1.88 8.35-5.95 14.45-6.65.14 0 .22.08.1.12a70.15 70.15 0 00-14.51 6.58s-.06-.03-.04-.05zM161.88 149.75c0-1.23.09-2.45.19-3.67V146l.05-.08a10 10 0 001.16-3.79 11.25 11.25 0 00-.37-4v-.17l.11-.09a11.16 11.16 0 012.59-1.68c-.4.32-.79.64-1.16 1s-.74.69-1.08 1.05l.06-.26a9.12 9.12 0 01.57 2.06 8.67 8.67 0 01.07 2.16 8.94 8.94 0 01-.46 2.11 7.23 7.23 0 01-1 1.94v-.13c-.2 1.23-.43 2.44-.73 3.63z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.55 153.33l27.92-.42s5.12 5.08 3.87 10.39-12 36.63-21.31 38.24-41.72-17.29-52.66-26.65-8.76-13.28 5.7-11.79 33.55 7.7 33.86 7.56-1-7.41-.83-10.3 3.45-7.03 3.45-7.03z",
    fill: "#92e3a9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.1 179.57a6 6 0 001.1.86c.07-.15.13-.31.2-.46a6.14 6.14 0 00-1.3-.4zm-10.64-20.39a8.47 8.47 0 00-2.11-.78 7.93 7.93 0 001.83 1.3 8.47 8.47 0 002.11.78 7.93 7.93 0 00-1.83-1.3zm-20.67 16.26a7.57 7.57 0 00-2.1-.78 8.69 8.69 0 003.93 2.07 7.89 7.89 0 00-1.83-1.29zm18.43 2.61a8.26 8.26 0 00-2.1-.78 7.93 7.93 0 001.83 1.3 8.26 8.26 0 002.1.78 7.93 7.93 0 00-1.83-1.3zm-19.91 13.41a7.57 7.57 0 00-.78 2.1 8.69 8.69 0 002.07-3.93 8.2 8.2 0 00-1.29 1.83zm25.76-4.46a7.57 7.57 0 00-.78 2.1 8.69 8.69 0 002.07-3.93 8.2 8.2 0 00-1.29 1.83zm-13.81-18.78a7.57 7.57 0 00-.78 2.1 7.6 7.6 0 001.29-1.83 7.51 7.51 0 00.78-2.11 8.26 8.26 0 00-1.29 1.84zm4.17 25.92a8.14 8.14 0 00-2 .93 7.7 7.7 0 002.21-.38 8 8 0 002-.93 7.76 7.76 0 00-2.21.38zm-24.28-9.5a8 8 0 00-2 .93 7.76 7.76 0 002.21-.38 8.3 8.3 0 002-.93 7.7 7.7 0 00-2.21.38zM154 170.23a8.3 8.3 0 00-.93-2 7.83 7.83 0 00.38 2.22 8.07 8.07 0 00.93 2 7.82 7.82 0 00-.38-2.22zm-40.72 3a7.68 7.68 0 00-.94-2 8.07 8.07 0 00.39 2.21 7.35 7.35 0 00.93 2 7.7 7.7 0 00-.43-2.19zm20.92 10.26a8.3 8.3 0 00-.93-2 7.83 7.83 0 00.38 2.22 8.07 8.07 0 00.93 2 7.82 7.82 0 00-.43-2.2zm.52-26.24a7.51 7.51 0 00-2.11-.78 8.79 8.79 0 003.94 2.07 7.6 7.6 0 00-1.88-1.27zm26.28 3.14a8.26 8.26 0 00-.78 2.1 7.72 7.72 0 001.3-1.83 8.26 8.26 0 00.78-2.1 7.93 7.93 0 00-1.3 1.83zm-55.53 20.05a7.57 7.57 0 00-2.1-.78 8.69 8.69 0 003.93 2.07 8.2 8.2 0 00-1.85-1.29zm-6.31-12.63a7.57 7.57 0 00-.78 2.1 8.69 8.69 0 002.07-3.93 7.6 7.6 0 00-1.31 1.83zm-8.21 5.76a4.93 4.93 0 00.11 1l.33.29.36.3a7 7 0 00-.82-1.59z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.66 163.16c1.3.5 2.58 1.08 3.84 1.68.57.27 1.14.55 1.72.81-3-.7-6-1.36-9-2-.09 0-.12.13 0 .16 4.64 1.44 9.34 2.74 14 3.94a118.19 118.19 0 0014 3.17.11.11 0 00.05-.22 117.58 117.58 0 00-14.06-3.91c-1.15-.29-2.3-.55-3.46-.82-.39-.25-.78-.5-1.19-.72a20 20 0 00-1.87-.89c-1.3-.54-2.63-1-4-1.4-.07.04-.12.17-.03.2zM95.91 181.41c.89.35 1.81.64 2.72.92.41.13.83.25 1.24.39-1.86-1.05-3.71-2.11-5.53-3.22v-.1c3 1.43 6 3 9 4.55a54.24 54.24 0 017 4 .08.08 0 01-.07.14 54.73 54.73 0 01-7.38-3.61c-.72-.39-1.43-.8-2.15-1.2l-.93-.18a13.15 13.15 0 01-1.35-.42c-.91-.33-1.79-.72-2.67-1.14.02-.06.06-.16.12-.13z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.4 153.24a16.8 16.8 0 00-3.29 5.95c-.65 2.25-.27 4.6 0 6.88q.46 3.84 1.27 7.61a1.84 1.84 0 00-.06.62v.8a18.91 18.91 0 00.38 3.09c0 .06.09 0 .09 0-.1-.74-.16-1.49-.21-2.24q0-.59-.06-1.17v-.49c.49 2.21 1.07 4.4 1.76 6.56 0 .08.17.06.14 0-1-4.67-1.89-9.37-2.47-14.12-.28-2.36-.77-4.9 0-7.2a57.34 57.34 0 012.62-6.15c.06-.16-.1-.22-.17-.14z",
    fill: "#263238"
  }))));
}
export default "/_next/static/media/Product-hunt-cuate.fc0c85351484c502c1bfddc801569f9f.svg";
export { SvgProductHuntCuate as ReactComponent };